























































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ShohiyouService } from "@/services/shohiyou.service.ts";
import {
  ShohiyouKoumoku,
  ShohiyoData,
  SeibiShohiyou
} from "@/models/ShohiyouKoumoku.ts";
import { Proposal, ProposalItem } from "@/models/Coupon.ts";
import Number from "@/shared/filters/Number";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import vuedraggable from "vuedraggable";
import { KyotenData } from "@/models/KyotenData";
import { CommonService } from "@/services/Common.service";
import { Utils } from "@/services/utils";

export interface ShohiyoDataTb extends ShohiyoData {
  isEdit?: boolean;
}

export interface ShohiyouKoumokuTb extends ShohiyouKoumoku {
  isEdit?: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination,
    draggable: vuedraggable
  }
})
export default class ShakenShohiyou extends Vue {
  @Prop({ default: "" })
  title: string;
  @Action("setShohiyouKoumoku", { namespace: "ShohiyouStore" })
  public setShohiyouKoumoku: any;

  public shohiyouService = new ShohiyouService();
  public shohiyoData: ShohiyoData;
  public shohiyoEdit: ShohiyoData;
  public shohiyouKoumokuList: ShohiyouKoumokuTb[] = [];
  // public shohiyouKoumokuItemList: ShohiyouKoumokuTb[] = [];
  public seibiShohiyou: SeibiShohiyou[] = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;

  private loading: boolean = false;

  commonService = new CommonService();
  public koumokuExtension: any = [];
  jidoushaShubetsuList: any = [];
  public showShubetsuDialog: boolean = false;
  util: Utils = new Utils();
  public updateKoumokuItem: any;

  constructor() {
    super();

    this.shohiyoData = {
      id: "",
      shohiyouKbn: "",
      shohiyouCd: "",
      shohiyouNm: "",
      kingaku: 0,
      genka: 0,
      kazeiKbn: "",
      defDispKbn: false
    };

    this.shohiyoEdit = {
      id: "",
      shohiyouKbn: "",
      shohiyouCd: "",
      shohiyouNm: "",
      kingaku: 0,
      genka: 0,
      kazeiKbn: "",
      defDispKbn: false
    };

  }
  public kyotenDataList: KyotenData[] = [];
  public form: any = {
    kyotenSelected: ""
  };
  public dialogFormVisible: boolean = false;
  maxItem: number = 10;
  disabledAdd: boolean = true;
  timerReOrder: any = null;
  loadingKoumokuExtension: boolean = false;

  get shohiyoIndex() {
    if (this.shohiyouKoumokuList.length == 0) {
      return 0;
    }
    const id = this.shohiyouKoumokuList[this.shohiyouKoumokuList.length - 1].id;
    return id ? id + 1 : 0;
  }

  public json(data: any): any {
    return JSON.parse(JSON.stringify(data));
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    if (this.shohiyoData.shohiyouNm) {
      this.loading = true;
      const data = { ...this.shohiyoData, id: this.shohiyoIndex };
      if (data.shohiyouKbn == "1") {
        data.shohiyouCd = "20003";
      }
      this.addShohiyouKoumoku({ ...data });
    }
  }

  public async getKyotenDataList() {
    const response = await this.shohiyouService.getKyotens();
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
  }

  public async getSeibiShohiyou() {
    const response = await this.shohiyouService.getSeibiShohiyou();
    if (response) {
      this.$set(this, "seibiShohiyou", response);
    }
  }

  public async getShohiyouKoumoku(id?: number) {
    const response = await this.shohiyouService.getShohiyouKoumoku(id);
    if (response) {
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "shohiyouKoumokuList", data);
      this.setShohiyouKoumoku(data);
    }
  }

  public async addShohiyouKoumoku(data: any) {
    const response = await this.shohiyouService.editShohiyouKoumoku(data);
    if (response) {
      this.getShohiyouKoumoku();
      this.delay(1000);
    } else {
      this.delay(1000);
    }
  }

  public async delShohiyouKoumoku(id: number) {
    this.loading = true;
    const response = await this.shohiyouService.deleteShohiyouKoumoku(id);
    if (response === 200) {
      this.getShohiyouKoumoku();
      this.delay(1000);
    } else {
      this.delay(1000);
    }
  }

  public async saveShohiyouKoumoku(data: any[]) {
    const response = await this.shohiyouService.saveShohiyouKoumoku(data);
    if (response) {
      console.log(response);
    }
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.shohiyoEdit = { ...rowData, defDispKbn: rowData.defDispKbn === 1 ? true : false };
  }

  public editShohiyouItem() {
    this.loading = true;
    if (
      this.shohiyoEdit.id &&
      this.shohiyoEdit.shohiyouKbn &&
      this.shohiyoEdit.shohiyouNm
    ) {
      const data = {
        id: this.shohiyoEdit.id,
        shohiyouKbn: this.shohiyoEdit.shohiyouKbn,
        shohiyouCd: this.shohiyoEdit.shohiyouCd,
        shohiyouNm: this.shohiyoEdit.shohiyouNm,
        kingaku: this.shohiyoEdit.kingaku,
        genka: this.shohiyoEdit.genka,
        kazeiKbn: this.shohiyoEdit.kazeiKbn,
        defDispKbn: this.shohiyoEdit.defDispKbn ? 1 : 0
      };
      this.addShohiyouKoumoku({ ...data });
    }
    this.dialogFormVisible = false;
  }

  private beforeMount() {
    this.getSeibiShohiyou();
    this.getShohiyouKoumoku();
    this.getKyotenDataList();
    this.form.kyotenSelected = localStorage.getItem("kyotenCd");
  }

  checkDisabledAdd() {
    let disabled = false;
    if (this.shohiyouKoumokuList.length >= this.maxItem) {
      disabled = true;
    } else if (this.shohiyoData.shohiyouNm === "") {
      disabled = true;
    }
    this.$set(this, "disableBtnAdd", disabled);
  }

  onClear() {
    this.shohiyoData = {
      id: "",
      shohiyouKbn: "",
      shohiyouCd: "",
      shohiyouNm: "",
      kingaku: 0,
      genka: 0,
      kazeiKbn: "",
      defDispKbn: false
    };
  }

  onEnd(event: any) {
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    this.timerReOrder = setTimeout(() => {
      const data = this.shohiyouKoumokuList.map((e: any) => {
        let item = { ...e };
        delete item.isEdit;
        return item;
      });
      this.shohiyouService.saveOrder(data);
    }, 1000);
  }

  private mounted() {
    this.getKbnSkns("jidoushaShubetsuList", "skn_jidousha_shubetsu", "7101");
  }

  public async getKbnSkns(nameKbn: string, sknTitle: string, kbnCd?: string) {
    const response = await this.commonService.getKbnSkns(sknTitle, kbnCd);
    if (response) {
      let data = response.filter((e: any) => e.isDisabled == 0);
      data = data.sort((a: any, b: any) => (a.num > b.num ? 1 : -1));
      this.$set(this, nameKbn, [...data]);
    } else {
      this.$set(this, nameKbn, []);
    }
  }

  public async updateKoumokuExtension() {
    let saveData = this.koumokuExtension.filter((e: any) => e.isUse == 1);
    saveData.forEach((e: any) => {
      delete e.isUse;
    });

    /** 保存を行う */
    await this.shohiyouService.saveShohiyouKoumokuExtension(this.updateKoumokuItem.id, saveData);

    /** 保存をした後、最新情報で、更新しておく */
    await this.getKoumokuExtension(this.updateKoumokuItem);
    this.showShubetsuDialog = false;
  }

  public async getKoumokuExtension(item: any) {
    this.koumokuExtension = [];
    this.jidoushaShubetsuList.forEach((jidoushaShubetsu: any) => {
      const extension = {
        id: null,
        sknShohiyouKoumokuId: item.id,
        jidoushaShubetsu: jidoushaShubetsu.kbnKey,
        kingaku: 0,
        genka: 0,
        isUse: 0
      };
      this.koumokuExtension.push(extension);
    });

    const response = await this.shohiyouService.getShohiyouKoumokuExtension(item.id);

    if (response) {
      response.forEach((responseData: any) => {
        this.koumokuExtension.forEach((extension: any) => {
          extension.sknShohiyouKoumokuId = item.id;
          if (extension.jidoushaShubetsu == responseData.jidoushaShubetsu) {
            extension.id = responseData.id;
            extension.kingaku = responseData.kingaku;
            extension.genka = responseData.genka;
            extension.isUse = 1;
          }
        });
      });
    }
  }

  public async showKoumokuExtension(item: any) {

    await this.getKoumokuExtension(item);
    this.updateKoumokuItem = item;
    this.showShubetsuDialog = true;
  }

  private shubetsu(item: any) {
    let data = this.jidoushaShubetsuList.filter((e: any) => e.kbnKey == item.jidoushaShubetsu);

    if (data && data.length > 0) {
      return data[0].value;
    }

    return "";
  }
}
